import { Container } from "@chakra-ui/react";
import styles from "./footer.module.scss";
import { MdRoom, MdPhone, MdMailOutline } from "react-icons/md";

const Footer = () => {
  return (
    <footer className={styles.footerContainer}>
      <Container>
        <div className={styles.footerContent}>
          <div className={styles.contactData}>
            <MdRoom className={styles.icon} />

            <a
              className={styles.address}
              target="_blank"
              href=" http://maps.google.com/?q=Algade 2 D 4281 Gørlev"
            >
              <p>BioLean ApS</p>
              <p>Algade 2 D</p>
              <p>4281 Gørlev</p>
              <p>Denmark</p>
            </a>
          </div>
          <div className={styles.contactData}>
            <MdPhone className={styles.icon} />
            <a href="tel:+4521283080">+45 21 28 30 80</a>
          </div>
          <div className={styles.contactData}>
            <MdMailOutline className={styles.icon} />
            <a href="mailto:info@biolean.dk">info@biolean.dk</a>
          </div>
        </div>
      </Container>
      <div className={styles.copyright}>
        <Container>
          <p>All rights reserved © 2025 BioLean ApS</p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
